import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import { useApi } from "../../apiHelpers";
import { useToast } from "../../components/Toast/ToastContext";
import { buttonClass } from "../../components/ui/Button";
import { Field } from "../../components/ui/Field";
import { Panel } from "../../components/ui/Panel";

const EditHistory = () => {
  // Retrieve URL parameters: drone_serial (serial number), id, and status.
  const { serialnumber, id: logID, status } = useParams();
  const history = useHistory();
  const api = useApi();
  const toast = useToast();

  // Local state for the fetched record and the editable log text.
  const [record, setRecord] = useState(null);
  const [logText, setLogText] = useState("");

  // Fetch the record on mount based on the status.
  useEffect(() => {
    const fetchRecord = async () => {
      const endpoint =
        status === "flag"
          ? `/flags/entry/${logID}`
          : `/maintenance/entry/${logID}`;

      try {
        const data = await api.get(endpoint);
        setRecord(data);
        setLogText(data.descript);
      } catch (error) {
        toast.error(`${status === "flag" ? "Flag" : "Maintenance"} not found, please try again`);
      }
    };

    fetchRecord();
  }, [logID, status]);

  // Handle form submission: PATCH the updated record.
  const handleSubmit = async (e) => {
    e.preventDefault();
    const updatedRecord = { ...record, descript: logText };
    const endpoint =
      status === "flag"
        ? `/flags/entry/${logID}`
        : `/maintenance/entry/${logID}`;

    try {
      await api.patch(endpoint, {
        body: updatedRecord
      });
      history.goBack();
    } catch (error) {
      toast.error(`Can't update ${status === "flag" ? "flag" : "maintenance"}, please try again`);
    }
  };

  // Cancel and navigate back.
  const handleCancel = () => history.goBack();

  return (
    <div className="flex items-center justify-center min-h-screen">
      <Panel label={`Edit ${status} for drone ${serialnumber}`} className="w-full max-w-md" padding="md">
      <form onSubmit={handleSubmit}>
        <h3 className="text-xl font-bold mb-4">DRONE {serialnumber}</h3>
        <label className="block text-gray-700 font-semibold mb-2">
          EDIT {status.toUpperCase()}
        </label>
        <Field
          type="text"
          className="mb-4"
          autoFocus
          value={logText}
          onChange={(e) => setLogText(e.target.value)}
        />
        <button
          type="submit"
          className={`${buttonClass("filled", "md")} w-full mb-2`}
        >
          Save
        </button>
        <button
          type="button"
          onClick={handleCancel}
          className={`${buttonClass("tonal", "md")} w-full`}
        >
          Cancel
        </button>
      </form>
      </Panel>
    </div>
  );
};

export default EditHistory;
